export const getEmailParts = (email) => {
  if (!email) return ['', ''];

  const emailArr = email.split('@');

  return [emailArr[0], emailArr.length > 1 ? emailArr[1] : ''];
};
